'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';

import Store from './store';
// Import JS Modules
import translate from '../_utils/tools/translate';

// -----------------------------------------------------------
//  StoresList
// -----------------------------------------------------------
const StoresList = (
  { stores },
  { selectedLocation, unavailableItems = [] },
) => {
  if (stores.length === 0) return null;

  let messages = [`${translate('Store')}s with all items available`];
  stores[0].orderTimestamps &&
    messages.push(' - all times are in your local timezone');
  messages.push(':');

  return (
    <div>
      <p>
        <strong>{messages.join('')}</strong>
      </p>
      <div className="store-locator-list">
        <table className="table">
          <tbody>
            {stores.map((store, i) => {
              return (
                <Store
                  key={i}
                  store={store}
                  selected={store.id == (selectedLocation || stores[0].id)}
                  unavailableItems={unavailableItems.filter(
                    (item) => item.storeId === store.id,
                  )}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

StoresList.propTypes = {
  stores: PropTypes.array.isRequired,
};

StoresList.contextTypes = {
  selectedLocation: PropTypes.string,
  unavailableItems: PropTypes.array,
};

export default StoresList;
